import React, {useMemo, useState} from 'react';
import {IconButton, MenuItem, TableCell, TableRow} from "@material-ui/core";
import {FullWidthTextField} from "@src/Shared/styles";
import DeleteIcon from "@material-ui/icons/Delete";
import {Position} from "@src/Interfaces/Entity/Position";
import {IError} from "@src/Components/Pages/Main/Content/Locations/LocationDialog/LocationDialog";

interface IPositionTabItemProps {
    item: Position,
    error?: IError;
    onChange: (position: Position) => void;
    onRemove: () => void;
    allPositions: Position[];
    takenPositionIds: string[];
    canEdit: boolean;
}

export const PositionTabItem = (props: IPositionTabItemProps) => {
    const [position, setPosition] = useState(props.item);
    
    const availablePositions = useMemo(() => {
        return props.allPositions.filter(pos => !props.takenPositionIds.includes(pos.id) || props.item.id == pos.id)
    }, [props.takenPositionIds, props.item]);

    const handleOnChange = (ev: any) => {
        const newPosition = props.allPositions.find(pos => pos.id === ev.target.value);
        setPosition(newPosition);
        props.onChange(newPosition);
    };

    return (
        <TableRow>
            <TableCell>
                <FullWidthTextField
                    select
                    disabled={!props.canEdit}
                    value={position.id}
                    error={props.error?.value}
                    label={props.error?.value}
                    onChange={(ev: any) => handleOnChange(ev)}
                    variant="outlined"
                    size={"small"}
                >
                    {availablePositions?.map((pos: any, i: number) => (
                        <MenuItem key={i} value={pos.id}>
                            {pos.name}
                        </MenuItem>)
                    )}
                </FullWidthTextField>
            </TableCell>

            <TableCell>
                {position.title}
            </TableCell>

            <TableCell>
                {position.description}
            </TableCell>

            <TableCell style={{width: 64}} size={"small"} align={"center"}>
                <IconButton onClick={() => props.onRemove()} disabled={!props.canEdit}>
                    <DeleteIcon/>
                </IconButton>
            </TableCell>
        </TableRow>
    );
};
